// Limites de legenda para posts orgânicos (diferente dos limites de anúncios
// pagos em `pages/AdsManager/utils/charLimits.ts`). `recommended` é o ponto
// em que a plataforma passa a truncar com "ver mais" no feed — ainda aceita
// texto além disso, só é visual. `hard` é o limite técnico real da API.
export interface CaptionLimit {
  recommended?: number;
  hard?: number;
}

export const POST_CAPTION_LIMITS: Record<string, CaptionLimit> = {
  linkedin: { recommended: 210, hard: 3000 },
  facebook: { recommended: 477, hard: 63206 },
  facebook_stories: { recommended: 477, hard: 63206 },
  instagram: { recommended: 125, hard: 2200 },
  instagram_stories: { recommended: 125, hard: 2200 },
  google: { recommended: 1500, hard: 1500 },
  google_my_business: { recommended: 1500, hard: 1500 },
  youtube: { recommended: 5000, hard: 5000 },
  tiktok: { recommended: 150, hard: 2200 },
};

// Entre as plataformas selecionadas, o post precisa caber no limite mais
// restritivo — combina pegando o menor valor de cada campo.
export function getStrictestCaptionLimit(
  platformIds: string[],
): CaptionLimit | undefined {
  if (platformIds.length === 0) return undefined;

  let recommended: number | undefined;
  let hard: number | undefined;

  for (const id of platformIds) {
    const limit = POST_CAPTION_LIMITS[id];
    if (!limit) continue;
    if (limit.recommended !== undefined) {
      recommended =
        recommended === undefined
          ? limit.recommended
          : Math.min(recommended, limit.recommended);
    }
    if (limit.hard !== undefined) {
      hard = hard === undefined ? limit.hard : Math.min(hard, limit.hard);
    }
  }

  if (recommended === undefined && hard === undefined) return undefined;
  return { recommended, hard };
}
